import { render, staticRenderFns } from "./laporan_renstra.vue?vue&type=template&id=5b1eff1f&"
import script from "./laporan_renstra.vue?vue&type=script&lang=js&"
export * from "./laporan_renstra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports